export default {
  init: function () {
    let finalTopThreePplVendorSlugs = [];
    let finalTopThreePplVendor = [];
    if (window.topThreePplVendorSlugs !== undefined) {
      //eslint-disable-next-line no-undef
      finalTopThreePplVendor = JSON.parse(topThreePplVendorSlugs)
    }
    $(document).mouseup(function (e) {
      let container = $('.search-form');

      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0) {
        $('.search-look-ahead').html('');
      }
    });

    $(document).on('click', '.sh-search-suggestions li', function () {
      if ($(this).find('a')[0])
        $(this).find('a')[0].click();
    });


    $(document).ready(function () {
      //Check if top vendors
      let tab = getQueryString('t');
      if (tab == 2) {
        $('#tab-top-vendors').click();
      }

      //Search
      $('#header-search-form').on('submit', function (event) {
        event.preventDefault();
      });

      $('.no-luck-search').on('click', function () {
        $('.mega-dropdown').removeClass('mega-toggle-on');
        $('.navbar-search.button-search-desktop').click();
      })
      $('#s').autocomplete({
        deferRequestBy: 200,
        preserveInput: true,
        beforeRender: function (container, suggestions) {
          let html = '';
          suggestions.forEach(function (suggestion, index) {
            if (index <= 7) {
              let suggestionHtml = '<li><a href="' + suggestion.data.url + '"><div class="post-name-wrapper"><div class="post-name">' + suggestion.value + '</div><div class="post-type">' + (suggestion.data.type === 'product' ? 'Service' : 'Vendor') + '</div></div></a></li>';
              html = html + suggestionHtml;
            }
          });

          let viewAllHtml = '<div class="view-all search-view-all-hidden"><a href="/categories">View all results for <strong>' + $(this).val() + '</strong></a></div>';
          //get inner html of each of the suggestion=' + $(this).val() + '">View all results for <strong>' + $(this).val() + '</strong></a></div>';
          $('.search-look-ahead').html('<ul>' + html + '</ul>' + viewAllHtml);
          $(container).removeAttr('style');
          $(container).html('');
        },
        lookup: function (query, done) {
          $.ajax({
            url: window.ajax.url,
            type: 'get',
            dataType: 'json',
            data: {
              action: 'search_products_and_vendors',
              q: query,
            },
            success: function (result) {
              let suggestions = [];
              result.data.forEach(function (element) {
                suggestions.push({
                  'value': element.name,
                  'data': element,
                });
              });

              let returnResults = {
                suggestions: suggestions,
              }

              done(returnResults);
            },
          });
        },
      });
      if ($('.search-box input').length > 0) {
        $('.search-box input').autocomplete({
          deferRequestBy: 200,
          appendTo: '.search-box-results',
          lookup: function (query, done) {
            $.ajax({
              url: window.ajax.url,
              type: 'get',
              dataType: 'json',
              data: {
                action: 'search_products_and_vendors',
                q: query,
              },
              success: function (result) {
                let suggestions = [];
                result.data.forEach(function (element) {
                  suggestions.push({
                    'value': element.name,
                    'data': element,
                  });
                });

                let returnResults = {
                  suggestions: suggestions,
                }

                done(returnResults);
              },
            });
          },
          onSelect(suggestion) {
            window.location.href = suggestion.data.url;
          },
        });
      }

      //Initialize Popovers
      initializePopover();

      //Vendor Layout Toggles
      $('.vendor-list-button').on('click', function () {
        $('.vendor-cards-button').removeClass('active');
        $('.vendor-list-button').addClass('active');
        $('.view-layout').removeClass('card-view-layout');
        $('.view-layout').addClass('list-view-layout');
      });
      $('.vendor-cards-button').on('click', function () {
        $('.vendor-list-button').removeClass('active');
        $('.vendor-cards-button').addClass('active');
        $('.view-layout').removeClass('list-view-layout');
        $('.view-layout').addClass('card-view-layout');
      });

      //Get the width of main th
      $('.vendors-table-wrapper .details-table .th').each(function () {
        var th_width = $(this).outerWidth();

        //Set footer th and td width
        $('.vendors-table-footer .th').css({'width': th_width + 'px'});
        $('.vendors-table-footer .td').css({'width': 'calc(100% - ' + th_width + 'px)'});
      });


      init_smooth_scrolling();

      //Subsection layout w/ submenu logic.
      if ($('.subsection_menu').length > 0) {
        //Collapses mobile menu on click
        $(document).on('click', '.subsection_menu__link', function () {
          $('.subsection_menu__tree').removeClass('show');
          $('.subsection-title-wrapper').addClass('collapsed');
        });

        let $header = $('.site-header');
        let headerHeight = $header.outerHeight();

        $(document).on('scroll', function () {
          let submenuTop = $('.subsection_menu').offset().top;
          let scrollPos = $(window).scrollTop();

          //Moves up the header once header reaches the submenu.
          //acts as if it's pushing it up.
          let newTop = submenuTop - (scrollPos + headerHeight);
          if (newTop < 0 && newTop >= -headerHeight) {
            $header.css('top', newTop + 'px');
          } else {
            $header.css('top', '0');
          }

          //Checks which section we are in to hightlight the nav items in the submenu.
          $('section').each(function () {
            let $this = $(this);
            let thisTop = $this.offset().top - 5;
            let thisHeight = $this.outerHeight();
            let thisBottom = thisTop + thisHeight;
            let hash = $this.attr('id');

            //Active Section Title
            let $thisLink = $('a.subsection_menu__link[data-hash="' + hash + '"]');
            let linkText = $thisLink.text();
            let $mobileText = $('.subsection_menu__button .subsection-title');

            //Sections Total Number
            let $sectionCount = $('.subsection-wrapper section').length;
            let $sectionTotal = $('.subsection_menu__button .subsection-total');
            $sectionTotal.text($sectionCount);

            //Active Class and Active Section Title
            if (scrollPos >= thisTop && scrollPos < thisBottom) {
              $thisLink.addClass('active');
              $mobileText.text(linkText);
            } else {
              $thisLink.removeClass('active');
            }

            //Active Section Number
            let $sectionActive = $('.subsection_menu__tree .active');
            let activeInt = $sectionActive.attr('data-int');
            let $sectionNumber = $('.subsection_menu__button .subsection-number');
            $sectionNumber.text(activeInt);

            //Arrow Buttons
            let prevSection = parseInt(activeInt) - 1;
            let nextSection = parseInt(activeInt) + 1;

            if (isNaN(prevSection) || isNaN(nextSection)) {
              prevSection = 0;
              nextSection = 2;
            }

            $('.subsection_menu__button .arrow-left').attr('href', '#subsection-' + prevSection).attr('data-hash', '#subsection-' + prevSection);
            $('.subsection_menu__button .arrow-right').attr('href', '#subsection-' + nextSection).attr('data-hash', '#subsection-' + nextSection);

          });

        }).trigger('scroll');
      }

      /**
       * Smooth scrolling on anchor click.
       */
      function init_smooth_scrolling() {
        //direct browser to top right away
        if (window.location.hash) {
          scroll(0, 0);
        }

        //takes care of some browsers issue
        setTimeout(function () {
          scroll(0, 0);
        }, 1);

        if (window.location.hash) {
          // smooth scroll to the anchor id
          $('html,body').animate({
            scrollTop: $(window.location.hash).offset().top + 'px',
          }, 1000, 'swing');
        }

        //Add smooth scrolling to all links
        $('a').on('click', function () {
          let hash = this.hash;
          let buttonId = $(this).attr('id') || '';

          //Using $'s animate() method to add smooth page scroll
          //The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
          //Check if hash exists on page, if not go to page
          if ($(hash).length && buttonId.indexOf('tab-') < 0) {
            $('html, body').animate({
              scrollTop: $(hash).offset().top,
            }, 800, function () {

              //Add hash (#) to URL when done scrolling (default click behavior)
              window.location.hash = hash;
            });
          }
          // } //End if
        });
      }
    });
    //Toggling the search overlay
    $('.button-search').on('click', function () {
      $('#s').val('');
      $('.button-search').toggleClass('open');

      //Hide Menu
      $('.navbar-toggler').addClass('collapsed');
      $('#primary-nav').removeClass('show');
      $('.site-header').removeClass('nav-open');

      if ($(window).width() < 769) {
        $('.site-header').toggleClass('search-open');
      }

      $('#search-form-container').toggleClass('search-open');

      $('#search-form-container input[type=\'text\']').trigger('focus');
      setTimeout(input_focus, 300);
    });

    //Menu Toggle
    $('.navbar-toggler').on('click', function () {
      $('.site-header').toggleClass('nav-open');

      //Hide Search
      $('.site-header').removeClass('search-open');
      $('.button-search').removeClass('open');
      $('#search-form-container').removeClass('search-open');
    });

    $('.request-demo, #solutions-request').on('click', function (e) {
      e.preventDefault();

      $(this).parent().toggleClass('active');
    });

    $(document).on('click', function (e) {
      if ($(e.target).hasClass('demo') || $(e.target).closest('.navbar-button.demo').length > 0) {
        return;
      }
      $('a.request-demo').parent().removeClass('active');
    })

    //Mega Menu Toggle
    let hoverTimeout;
    $('li.mega-dropdown').on({
      mouseenter: function () {
        clearTimeout(hoverTimeout);
        $('li.mega-dropdown').removeClass('mega-toggle-on');

        $('body').addClass('mega-open');
        $(this).addClass('mega-toggle-on');
        $('#sub-menu .nav-button').removeClass('active');
      },
      mouseleave: function () {
        let $this = $(this);

        hoverTimeout = setTimeout(function () {
          $('body').removeClass('mega-open');
          $(this).removeClass('mega-toggle-on');
          $this.removeClass('mega-toggle-on');
          $('li.mega-dropdown').removeClass('mega-toggle-on');
        }, 500);
      },
    });

    //Position mega menu arrow below vendors
    if ($(window).width() > 992) {
      // arrow_offset();
    }

    //Vendor Layout Toggles
    $('.vendor-list-button').on('click', function () {
      $('.vendor-cards-button').removeClass('active');
      $('.vendor-list-button').addClass('active');
      $('.view-layout').removeClass('card-view-layout');
      $('.view-layout').addClass('list-view-layout');
    });

    $('.vendor-cards-button').on('click', function () {
      $('.vendor-list-button').removeClass('active');
      $('.vendor-cards-button').addClass('active');
      $('.view-layout').removeClass('list-view-layout');
      $('.view-layout').addClass('card-view-layout');
    });

    //Carets
    $('[data-toggle="dropdown"]').on('click', function (e) {
      e.stopPropagation();
      $(this).parent().toggleClass('open');
    });

    //Disable auto-closing of dropdowns (1 of 2).
    $(document).data('bs-nav-closable', false);

    //Disable auto-closing of dropdowns (2 of 2).
    $(document).on({
      'shown.bs.dropdown': function () {
        $(this).data('bs-nav-closable', false);
      },
      'click': function () {
        $(this).data('bs-nav-closable', false);
      },
      'hide.bs.dropdown': function () {
        return $(this).data('bs-nav-closable');
      },
    });

    //Auto-open current and parent menu items on mobile/tablet.
    if ($(window).width() < 992) {
      $('.current-menu-ancestor.dropdown').each(function () {
        $(this).addClass('open');
      });

      $('.current-menu-ancestor.dropdown').each(function () {
        $(this).addClass('open');
      });
    }

    //Checkboxes
    $('.facet-checkbox').on('click', function () {
      $(this).toggleClass('checked');
    });

    $(window).on('resize', function () {
      //Position mega menu arrow below vendors
      if ($(window).width() > 992) {
        // arrow_offset();
      }

      //Get the width of main th
      $('.vendors-table-wrapper .details-table .th').each(function () {
        let th_width = $(this).outerWidth();

        //Set footer th and td width
        $('.vendors-table-footer .th').css({'width': th_width + 'px'});
        $('.vendors-table-footer .td').css({'width': 'calc(100% - ' + th_width + 'px)'});
      });
    });

    //Sticky Vendors Filter
    let filters = $('.vendors-filter');
    if (filters.length) {
      let stickyOffset = $('.vendors-filter').offset().top;
      $(window).on('scroll', function () {
        let sticky = $('.vendors-filter'),
          scroll = $(window).scrollTop();

        if ($(window).width() < 992) {
          if (scroll >= stickyOffset) {
            sticky.addClass('sticky');
          } else {
            sticky.removeClass('sticky');
          }
        }
      });
    }

    //Put cursor in search form on open.
    function input_focus() {
      $('#search-form-container #s').trigger('focus');
    }

    $('#show-more-vendors').on('click', function () {
      $(this).addClass('active');
      setQueryString();
      sendAjaxRequest(false);
    });

    //SORT BY START
    $('.vendor-sorting > button').on('click', function () {
      $(this).addClass('active');
      $(this).siblings('button').removeClass('active');
    });
    let sortFilter = 'default';

    // window.resetSort = function () {
    //   $('.sh-vendor-list-container').html('');
    //   sortFilter = 'default';
    //   sendAjaxRequest();
    // }
    //
    // //eslint-disable-next-line no-unused-vars
    // window.sortByRating = function () {
    //   $('.sh-vendor-list-container').html('');
    //   sortFilter = 'rating';
    //   sendAjaxRequest();
    // }
    //
    // window.sortByReviews = function () {
    //   $('.sh-vendor-list-container').html('');
    //   sortFilter = 'reviews';
    //   sendAjaxRequest();
    // }
    //
    // window.sortAlphabetical = function () {
    //   $('.sh-vendor-list-container').html('');
    //   sortFilter = 'alphabetical';
    //   sendAjaxRequest();
    // }
    //SORT BY END

    //Vendor Search start - compare
    $('#sh-vendor-search').keyup(function () {
      let vendorSearch = $('#sh-vendor-search').val();
      vendorSeachAjaxRequest(vendorSearch);
    });

    function vendorSeachAjaxRequest(vendorSearch) {
      let productId = $('#productId').attr('data-value');

      filter = $.ajax({
        url: window.ajax.url,
        type: 'get',
        dataType: 'json',
        data: {
          action: 'vendor_search',
          productId: productId,
          searchTerm: vendorSearch,
        },
        success: function (result) {
          $('.sh-vendor-search-container').html('');
          $('.sh-vendor-search-container').append(result.data.vendors);
        },
      })
    }

    //Vendor search end

    //Get vendor start - compare
    $('.sh-vendor-search-item').click(function () {
      let vendorSlug = $(this).attr('data-slug')
      getVendorAjaxRequest(vendorSlug);
    });

    function getVendorAjaxRequest(vendorSlug) {
      let productId = $('#productId').attr('data-value');

      filter = $.ajax({
        url: window.ajax.url,
        type: 'get',
        dataType: 'json',
        data: {
          action: 'get_vendor',
          productId: productId,
          vendorSlug: vendorSlug,
        },
        success: function (result) {
          $('.sh-vendor-item-container').html('');
          $('.sh-vendor-item-container').append(result.data.vendor);
        },
      })
    }

    //Get vendor end - compare

    //Filters start
    let filter;
    let searchTerm = '';


    //new filters
    $('.sh-filter-features .sh-button-primary , .sh-group-size .sh-button-primary').on('click', function () {
      removeQueryString('paged');
      sendAjaxRequest(true);
      $(this).closest('.sh-options').slideToggle()
    });

    $('.sh-radio-input.sh-filter-by-rating').on('click', function () {
      $('.sh-radio-input.sh-filter-by-rating').prop('checked', false)
      $(this).prop('checked', true)
    });

    $('.sh-filter-features .sh-button-clear , .sh-group-size .sh-button-clear').on('click', function () {
      $(this).closest('.sh-options').find('input[type="checkbox"]').prop('checked', false);
      $(this).closest('.sh-options').find('input[type="radio"]').prop('checked', false);
      $(this).closest('.sh-options').find('input[type="text"]').val('');
      removeQueryString('paged');
      sendAjaxRequest(true);
      $(this).closest('.sh-options').slideToggle()
    });

    $('.sh-filter-clear-mobile').on('click', function () {

      $('.sh-options').find('input[type="checkbox"]').prop('checked', false);
      $('.sh-options').find('input[type="radio"]').prop('checked', false);
      $('.sh-options').find('input[type="text"]').val('');
      removeQueryString('paged');
      sendAjaxRequest(true);

    });

    $('.sh-filters-mobile').on('click', function () {
      if ($('.sh-filters').hasClass('sh-flex')) {
        $('.sh-filters').removeClass('sh-flex');
        $('.sh-options').removeClass('sh-options-mobile');
      } else {
        $('.sh-filters').addClass('sh-flex');
        $('.sh-options').addClass('sh-options-mobile');
      }
    });


    $('.sh-sortby-filter li').on('click', function () {
      sortFilter = $(this).data('value');
      $('.sh-sortby-filter li').removeClass('active');
      $(this).addClass('active');

      removeQueryString('paged');
      sendAjaxRequest(true);
      $('.sh-sortby-filter .sh-select-header b').text($(this).text())
    });

    //sh-group-size-input
    $('.sh-group-size-input').keypress(function () {
      if ($(this).val().length > 0)
        $(this).closest('.sh-options').find('.sh-button-clear').removeClass('disabled');
      else
        $(this).closest('.sh-options').find('.sh-button-clear').addClass('disabled');
    });


    $(document).on('click', '.sh-search .search-icon', function () {
      searchTerm = $('#sh-filter-search').val();
      if (searchTerm.length > 0) {
        removeQueryString('paged');
        sendAjaxRequest(true);
        return
      } else {
        $('#sh-filter-search').closest('.sh-search').toggleClass('active');

        if (!$('#sh-filter-search').closest('.sh-search').hasClass('active'))
          $('.sh-search .x-icon').hide();
      }
    });


    $('.sh-search .x-icon').click((e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      $('#sh-filter-search').val('');
      $('.sh-search .x-icon').hide();
      searchTerm = '';
      removeQueryString('paged');
      sendAjaxRequest(true);
    });


    $('#sh-filter-search').keypress(function (e) {
      let key = (e.key !== undefined) ? e.key : e.keyCode;
      searchTerm = $('#sh-filter-search').val();

      if (searchTerm.length == 0)
        $('.sh-search .x-icon').hide();
      else
        $('.sh-search .x-icon').show();

      if (key == 'Enter' || key == 13) {
        removeQueryString('paged');
        sendAjaxRequest(true);
      }
    });


    const emptyBox = `<div class="sh-card">
       <div style="width: 100%; margin-bottom: 20px">
         <div class="sh-hero" style="display: flex">
           <div class="hero-main" style="width: auto">
             <div class="logo-container skeleton-loader"></div>
           </div>
           <div style="height: 26px;
    width: 400px;    margin: auto auto auto 40px;
    border-radius: 5px;" class="skeleton-loader">
           </div>
           <div class="hero-buttons">
               <button type="button" style="width: 156px; height: 44px;" href="#" class="sh-button-primary get-in-contact-button skeleton-loader">
               </button>
             <button type="button"  style="width: 156px; height: 44px;"  href="#" class="sh-button-primary get-in-contact-button skeleton-loader">
             </button>
           </div>
         </div>
         <div class="sh-card-tabs skeleton-loader" style="height: 24px; width: 100%;"></div>
         <div class="sh-card-content-wrap sh-tab-product">
           <div class="sh-card-specs-wrap skeleton-loader" style="min-height: 200px;"></div>
           <div class="sh-card-description ">
             <h3 class="skeleton-loader">&nbsp;</h3>
             <ul >
               <li class="skeleton-loader">
                 <span>&nbsp;</span>
               </li>
               <li class="skeleton-loader">
                 <span>&nbsp;</span>
               </li>
               <li class="skeleton-loader">
                 <span>&nbsp;</span>
               </li>
               <li class="skeleton-loader">
                 <span>&nbsp;</span>
               </li>
             </ul>

             <h3 class="skeleton-loader">&nbsp;</h3>
             <p class="skeleton-loader">&nbsp;</p>
             <p class="skeleton-loader">&nbsp;</p>
             <p class="skeleton-loader">&nbsp;</p>
           </div>
         </div>
       </div>
     </div>`;

    const emptyBoxMobile = ` <div class="sh-card">
        <div style="width: 100%;">
          <div class="sh-hero" style="display: flex">
            <div class="hero-main" style="width: auto">
              <div class="logo-container skeleton-loader"></div>
            </div>
            <div style="height: 26px;
    width: 400px;    margin: auto auto auto 40px;
    border-radius: 5px;" class="skeleton-loader">
            </div>
          </div>
          <div class="hero-buttons">
            <button type="button" style="width: 156px; height: 44px; border-radius: 8px;" href="#" class="sh-button-primary get-in-contact-button skeleton-loader">
            </button>
            <button type="button"  style="width: 156px; height: 44px; border-radius: 8px;"  href="#" class="sh-button-primary get-in-contact-button skeleton-loader">
            </button>
          </div>
          <div class="sh-card-content-wrap sh-tab-product" style="margin-top: 20px">
              <p class="skeleton-loader">&nbsp;</p>
              <p class="skeleton-loader">&nbsp;</p>
          </div>
        </div>
      </div>`;


    function setFiltersCount(rating, groupSize, features) {

      $('.sh-rating-count,.sh-features-count,.sh-size-count,.sh-filters-count').html('').parent().removeClass('sh-active-filter').parent().removeClass('sh-active-filter');

      let filtersCount = 0;
      if (rating.length > 0) {
        $('.sh-rating-count').html(` (${rating.length})`);
        $('.sh-rating-count').parent().parent().addClass('sh-active-filter');
        filtersCount++;
      }

      if (features.length > 0) {
        $('.sh-features-count').html(` (${features.length})`);
        $('.sh-features-count').parent().parent().addClass('sh-active-filter');
        filtersCount++;
      }

      if (groupSize > 0) {
        $('.sh-size-count').html(` (${groupSize})`);
        $('.sh-size-count-count').parent().addClass('sh-active-filter');
        filtersCount++;
      }

      if (filtersCount > 0) {
        $('.sh-filters-count').parent().parent().addClass('sh-active-filter');
        $('.sh-filters-count').html(` (${filtersCount})`);
        $('.sh-enable-filters span.sh-vendor-count').html(`${filtersCount}`);
        $('.sh-enable-filters span.sh-vendor-count').show();
        $('.sh-filter-clear-mobile').addClass('active');
      } else {
        $('.sh-enable-filters span.sh-vendor-count').hide();
        $('.sh-filter-clear-mobile').removeClass('active');
      }
    }

    let prev_rating = '';
    let prev_groupSize = '';
    let prev_features = '';
    let prev_page = '';
    let prev_search = '';
    let prev_sortFilter = '';

    function compareValues(val1, val2) {
      return JSON.stringify(val1) == JSON.stringify(val2)
    }

    function sendAjaxRequest(isFilter = false) {
      let rating = getFilterValues('sh-filter-by-rating:checked');
      let groupSize = $('.sh-group-size-input').val();
      let features = getFilterValues('sh-filter-by-features:checked');
      let page = getQueryString('paged');
      let productSlug = $('#product-slug').val();

      if (compareValues(rating, prev_rating) &&
        compareValues(groupSize, prev_groupSize) &&
        compareValues(features, prev_features) &&
        compareValues(page, prev_page) &&
        compareValues(sortFilter, prev_sortFilter) &&
        prev_search == searchTerm)
        return;

      prev_rating = [...rating];
      prev_features = [...features];
      prev_groupSize = groupSize;
      prev_search = searchTerm;
      prev_page = page;
      prev_sortFilter = sortFilter;

      setFiltersCount(rating, groupSize, features);
      $('.vendor-list-spinner').removeClass('hidden');

      //Cancel previous request
      if (filter && typeof filter.abort === 'function') {
        filter.abort();
      }

      if (isFilter) {
        if ($(window).width() < 700)
          $('.sh-vendor-list-container').html(`${emptyBoxMobile}${emptyBoxMobile}${emptyBoxMobile}`);
        else
          $('.sh-vendor-list-container').html(`${emptyBox}${emptyBox}${emptyBox}`);
      }


      filter = $.ajax({
        url: window.ajax.url,
        type: 'get',
        dataType: 'json',
        data: {
          action: 'filter_listing',
          rating: rating,
          groupSize: groupSize,
          features: features,
          page: page,
          sort: sortFilter,
          productSlug: productSlug,
          searchTerm: searchTerm,
        },
        success: function (result) {

          if (isFilter)
            $('.sh-vendor-list-container').html('');

          $('.sh-vendor-list-container').append(result.data.items);
          $('.sh-top-vendor-list-total').text(result.data.total);
          $('.vendor-list-spinner').addClass('hidden');

          $('.sh-compare-box').each(function () {
            const vendorSlug = $(this).find('.sh-box-delete').data('vendor');
            if (!vendorSlug)
              return;
            const vendorToCompare = $(`.sh-card[data-vendor="${vendorSlug}"]`);
            vendorToCompare.addClass('checked');
            vendorToCompare.find('.sh-checkbox').addClass('active');
            vendorToCompare.find('.sh-checkbox-input').prop('checked', true);
          });

          if (result.data.showing >= result.data.total) {
            $('#show-more-vendors').hide();
          } else {
            $('#show-more-vendors').show();
          }

          $('#show-more-vendors').removeClass('active');
          initializePopover();
        },
      })
    }

    function getFilterValues(filterClass) {
      return $('.' + filterClass).map(function () {
        return $(this).attr('data-value')
      }).get();
    }

    //Filters end

    //Compare start
    let compareVendor = [];
    let productSlug = '';

    $('.compare-item-close').on('click', function () {
      let position = $(this).parents('.compare-bottom-item').removeClass('bg-white').attr('position');

      $('.compare-button.checked[position="' + position + '"]').removeClass('checked');
      compareVendor.splice(position - 1, 1);
      removeElementFromBar(position);

      //Hide bar
      hideBar();
    });

    $('.compare-bottom-remove-all').on('click', function () {
      $('.compare-button.checked').each(function (index) {
        $(this).removeClass('checked');
        // let element = $(this).attr('position');
        removeElementFromBar(index);
      });
      compareVendor = [];
      hideBar();
    })
    //eslint-disable-next-line no-unused-vars
    window.addVendorCompare = function (vendor, product, button) {
      let checked = $(button).hasClass('checked');

      //Set product slug
      if (productSlug.length === 0) {
        productSlug = product;
      }

      if (checked || compareVendor.length < 5) {
        $(button).toggleClass('checked');
      }

      //Add vendor to compare array
      if (!checked && compareVendor.length < 5) {
        compareVendor.push(vendor);
        let position = compareVendor.length;
        $(button).attr('position', position);
        addVendorToBottomCompareBar(vendor);
        //Check if bar visible if not, Show bar
        showBar();

        return;
      }

      //If unchecked, remove the vendor from array
      let position = $(button).attr('position');
      $(button).removeAttr('position')
      compareVendor.splice(position - 1, 1);
      removeElementFromBar(position);
      hideBar();
    }

    function addVendorToBottomCompareBar(vendor) {
      let vendorPosition = compareVendor.length - 1;

      $('.compare-bottom-item').eq(vendorPosition).find('.compare-item-close').removeClass('invisible');
      $('.compare-bottom-item').eq(vendorPosition).find('img').attr('src', 'https://d36w3vgtkvgnsp.cloudfront.net/' + vendor.logo);
      $('.compare-bottom-item').eq(vendorPosition).attr('position', compareVendor.length).addClass('bg-white');
      $('.vendor-compare-count').text(compareVendor.length);
    }

    function removeElementFromBar(position) {
      $('.vendor-items-container .compare-bottom-item').eq(position - 1).find('img').attr('src', '');
      $('.vendor-items-container .compare-bottom-item').eq(position - 1).find('.compare-item-close').addClass('invisible');
      $('.vendor-items-container .compare-bottom-item').eq(position - 1).removeAttr('position').removeClass('bg-white');
      $('.vendor-items-container .compare-bottom-item').eq(position - 1).appendTo('.vendor-items-container');
      $('.vendor-compare-count').text(compareVendor.length);

      //Adjust positions
      $('.vendor-items-container .compare-bottom-item').each(function () {
        let vendorPosition = $(this).attr('position');

        if (vendorPosition > position) {
          $(this).attr('position', vendorPosition - 1);
        }
      });

      $('.compare-button.checked').each(function () {
        let vendorPosition = $(this).attr('position');

        if (vendorPosition > position) {
          $(this).attr('position', vendorPosition - 1);
        }
      });
    }

    function showBar() {
      if (compareVendor.length === 1 && $('.compare-bottom-popup').hasClass('hidden')) {
        $('.compare-bottom-popup').removeClass('hidden');
      }
    }

    function hideBar() {
      if (compareVendor.length === 0) {
        $('.compare-bottom-popup').addClass('hidden');
      }
    }


    //Compare end

    //Request info start
    let lastPopup;
    $('.request-info-popup .popup-item-close').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      jQuery('.popup-container').addClass('p-4');
      jQuery('.popup-container').removeClass('sh-get-guide-form-container');
      jQuery('.popup-request-form').removeClass('sh-get-guide-form');
      $('.request-info-popup').addClass('hidden');
      $('.popup-request-form').text('').addClass('hidden');
      $('.request-info-popup .loader').addClass('hidden');
      $('.popup-already-contacted p').addClass('invisible');
      $('.popup-already-contacted').addClass('hidden');
      $('.popup-already-contacted-magnet p').addClass('invisible');
      $('.popup-already-contacted-magnet').addClass('hidden');
      $('.popup-already-contacted-unlock p').addClass('invisible');
      $('.popup-already-contacted-unlock').addClass('hidden');
      $('.popup-max-download-limit p').addClass('invisible');
      $('.popup-max-download-limit').addClass('hidden');
      removeCompareVendors();
    });

    $('.ppl-popup .popup-item-close, .ppc-popup-no-thanks').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      $('.ppl-popup .text-ppl-popup-first').text('Thank you! [Vendor Name] will be reaching out based on your request for information.');
      $('.ppl-popup .text-ppl-popup-second').text('Would you also like to receive a price quote & more information from a few of [Vendor Name]’s key competitors?');
      removeCompareVendors();
    });

    window.openRequestInfoPopUp = function (button, vendors = [], product = '', vendorName = []) {
      lastPopup = $(button).parents('.popup');
      lastPopup.addClass('hidden');
      $('body').css('top', '-' + document.documentElement.scrollTop + 'px').addClass('disable-scroll');
      $('iframe[title="recaptcha challenge expires in two minutes"]').eq(1).parent().css('top', '10vh');
      $('.request-info-popup .loader').removeClass('hidden');
      $('.request-info-popup').removeClass('hidden');
      $('.popup-request-form').removeClass('hidden');

      if (vendors.length === 0) {
        vendors = compareVendor;
      }

      if (product.length === 0) {
        product = productSlug;
      }

      // eslint-disable-next-line no-undef
      if (typeof window.topThreePplVendor !== 'undefined' && window.topThreePplVendor !== 'null') {
        let topThreePplVendorSlugs = JSON.parse(window.topThreePplVendor).map(vendor => vendor.slug);
        let vendorSlugs = vendors.map(vendor => vendor.slug);
        finalTopThreePplVendorSlugs = topThreePplVendorSlugs.filter(val => !vendorSlugs.includes(val));
        let newParse = JSON.parse(window.topThreePplVendor).filter(vendor => !vendorSlugs.includes(vendor.slug));
        let randomItems = newParse.slice(); // Make a copy of the vendors array

        for (let i = randomItems.length - 1; i > 0; i--) {
          let j = Math.floor(Math.random() * (i + 1));
          let temp = randomItems[i];
          randomItems[i] = randomItems[j];
          randomItems[j] = temp;
        }

        finalTopThreePplVendor = randomItems.slice(0, 3);

      }
      // eslint-disable-next-line no-undef
      let showTopThreePplVendor = typeof window.topThreePplVendor !== 'undefined' && window.topThreePplVendor !== 'null' && finalTopThreePplVendorSlugs.length;

      $.ajax({
        url: window.ajax.url,
        type: 'get',
        dataType: 'json',
        data: {
          action: 'hub_spot_form',
          vendors: vendors.map(vendor => {
            return {'slug': vendor.slug};
          }),
          product: product,
          topThreePpcVendor: showTopThreePplVendor,
        },
        success: function (result) {
          if (showTopThreePplVendor) {
            generatePplPopupVendors(finalTopThreePplVendor);
          }
          if (vendorName.length > 0 || compareVendor.length === 1) {
            let names = vendorName.length > 0
              ? vendorName.join('’s, ')
              : compareVendor.map(vendor => vendor.name).join('’s, ');

            let firstSentence = $('.ppl-popup .text-ppl-popup-first').text();
            let secondSentence = 'Would you also like to receive a price quote & more information from a few of ' + names + '’s key competitors?';
            $('.ppl-popup .text-ppl-popup-first').text(firstSentence.replace('[Vendor Name]', names));
            $('.ppl-popup .text-ppl-popup-second').text(secondSentence);
          }

          if (compareVendor.length > 1) {
            let firstSentence = $('.ppl-popup .text-ppl-popup-first').text();
            let names = compareVendor.map(vendor => vendor.name);
            $('.ppl-popup .text-ppl-popup-first').text(firstSentence.replace('[Vendor Name]', names.join(', ')));
            $('.ppl-popup .text-ppl-popup-second').text('They might need more specific information about the program you’re looking for, so that they can provide pricing on the most appropriate features and components.');
          }

          $('.popup-request-form').empty().append(result.data.form);
          if (result.data.evaluate) {
            let scriptContainer = document.getElementsByClassName('popup-request-form');
            let script = scriptContainer[0].getElementsByTagName('script');
            eval(script[0].innerHTML);
            setTimeout(function () {
              $('body > div:last-child > div:last-child').css('top', '10vh');
              $('body > div:nth-last-child(2) > div:last-child').css('top', '10vh');
            }, 2000);
          }
          $('.request-info-popup .loader').addClass('hidden');
        },
      })
    }
    //Request info end

    //Here start open lead magnet from
    window.openLeadMagnetPopUp = function (button, vendors = [], download, doc_title, downloadAll = []) {
      $('#sh-modal-compare').css('display', 'none');
      $('body').removeClass('sh-modal-open');

      lastPopup = $(button).parents('.popup');
      lastPopup.addClass('hidden');
      $('body').css('top', '-' + document.documentElement.scrollTop + 'px').addClass('disable-scroll');
      $('iframe[title="recaptcha challenge expires in two minutes"]').eq(1).parent().css('top', '10vh');
      $('.request-info-popup .loader').removeClass('hidden');
      $('.request-info-popup').removeClass('hidden');
      $('.popup-request-form').removeClass('hidden');

      $.ajax({
        url: window.ajax.url,
        type: 'get',
        dataType: 'json',
        data: {
          action: 'hub_spot_form',
          vendors: vendors.map(vendor => {
            return {'slug': vendor.slug};
          }),
          download: download,
          document_name: doc_title,
          downloadAll: downloadAll,
        },
        success: function (result) {
          $('.popup-request-form').empty().append(result.data.form);
          let scriptContainer = document.getElementsByClassName('popup-request-form');
          let script = scriptContainer[0].getElementsByTagName('script');

          if (result.data.evaluate) {
            eval(script[0].innerHTML);
          }
          setTimeout(function () {
            $('body > div:last-child > div:last-child').css('top', $('body').css('top').replace('-', ''));
            $('body > div:nth-last-child(2) > div:last-child').css('top', $('body').css('top').replace('-', ''));
          }, 2000);
          enableScroll();
          $('.request-info-popup .loader').addClass('hidden');
        },
      });
    }

    //Unlock data form
    window.openUnlockDataPopUp = function (button) {
      $('[data-toggle="tooltip"]').tooltip('hide')
      lastPopup = $(button).parents('.popup');
      lastPopup.addClass('hidden');
      $('body').css('top', '-' + document.documentElement.scrollTop + 'px').addClass('disable-scroll');
      $('iframe[title="recaptcha challenge expires in two minutes"]').eq(1).parent().css('top', '10vh');
      $('.request-info-popup .loader').removeClass('hidden');
      $('.request-info-popup').removeClass('hidden');
      $('.popup-request-form').removeClass('hidden');

      $.ajax({
        url: window.ajax.url,
        type: 'get',
        dataType: 'json',
        data: {
          action: 'hub_spot_form',
          unlock_data_form: true,
        },
        success: function (result) {
          $('.popup-request-form').empty().append(result.data.form);
          let scriptContainer = document.getElementsByClassName('popup-request-form');
          let script = scriptContainer[0].getElementsByTagName('script');

          if (result.data.evaluate) {
            eval(script[0].innerHTML);
          }
          setTimeout(function () {
            $('body > div:last-child > div:last-child').css('top', '10vh');
            $('body > div:nth-last-child(2) > div:last-child').css('top', '10vh');
          }, 2000);

          $('.request-info-popup .loader').addClass('hidden');
        },
      });
    }

    window.openDownladGuideForm = function (button,formId) {
      
      $('[data-toggle="tooltip"]').tooltip('hide')
      lastPopup = $(button).parents('.popup');
      lastPopup.addClass('hidden');
      $('body').css('top', '-' + document.documentElement.scrollTop + 'px').addClass('disable-scroll');
      $('.request-info-popup .loader').removeClass('hidden');
      $('.request-info-popup').removeClass('hidden');
      $('.popup-request-form').removeClass('hidden');

      $.ajax({
        url: window.ajax.url,
        type: 'get',
        dataType: 'json',
        data: {
          action: 'hub_spot_form',
          is_article: true,
          article_form_id: formId,
        },
        success: function (result) {
          
          $('.popup-request-form').empty().append(result.data.form);
          let scriptContainer = document.getElementsByClassName('popup-request-form');
          let script = scriptContainer[0].getElementsByTagName('script');

          if (result.data.evaluate) {
            eval(script[0].innerHTML);
          }
          setTimeout(function () {
            $('body > div:last-child > div:last-child').css('top', '10vh');
            $('body > div:nth-last-child(2) > div:last-child').css('top', '10vh');
          }, 2000);

          $('.request-info-popup .loader').addClass('hidden');
        },
      });
    }

    function removeCompareVendors() {
      $('.compare-button.checked').each(function (index) {
        $(this).removeClass('checked');
        removeElementFromBar(index);
      });
      compareVendor = [];
      hideBar();
      enableScroll();
    }

    function removeQueryString(queryString) {
      let url = new URL(window.location.href);
      let searchParams = new URLSearchParams(url.search)
      searchParams.delete(queryString);

      let newRelativePathQuery = window.location.pathname + (searchParams.toString().length > 0 ? '?' + searchParams.toString() : '');
      history.pushState(null, '', newRelativePathQuery);
    }

    function setQueryString() {
      if ('URLSearchParams' in window) {
        let searchParams = new URLSearchParams(window.location.search)
        let currentPage = searchParams.get('paged');
        let page = currentPage ? parseInt(currentPage) + 1 : 2;
        searchParams.set('paged', page.toString());
        let newRelativePathQuery = window.location.pathname + '?' + searchParams.toString();
        history.pushState(null, '', newRelativePathQuery);
      }
    }

    function getQueryString(queryString) {
      let searchParams = new URLSearchParams(window.location.search)

      return searchParams.get(queryString);
    }

    //PPC

    // eslint-disable-next-line no-unused-vars
    function get(path, parameters) {
      let url = new URL(path);
      Object.keys(parameters).forEach(key => url.searchParams.append(key, parameters[key]));
      return url.toString();
    }

    window.ppcClick = function (vid, uid, ref, link_from, showLead) {
      if (window.ajax.use_external_click_script) {
        ppcExternalClickScript(vid, uid, ref, link_from, showLead);
      } else {
        ppcClickApi(vid, uid, ref, link_from, showLead);
      }
    }

    function ppcClickApi(vid, uid, ref, link_from, showLead) {
      let newWindow = window.open('', '_blank');

      $.ajax({
        url: window.ajax.api_host + '/api/public/v1/external-click/ppc',
        type: 'post',
        dataType: 'json',
        data: {
          referer: ref,
          uid: uid,
          vendor_slug: vid,
          link_from: link_from,
          show_lead: showLead,
        },
        headers: {
          'Client-ID': window.ajax.api_client_id,
          'Client-Secret': window.ajax.api_client_secret,
        },
        success: function (result) {
          let redirectUrl = result.redirect_url;
          if (redirectUrl && newWindow) {
            newWindow.location.href = redirectUrl;
            newWindow.focus();
          }
        },
      });
    }

    function ppcExternalClickScript(vid, uid, ref, link_from, showLead) {
      let parameter = {
        'vid': vid,
        'uid': uid,
        'ref': ref,
        'fp': 2,
        'link_from': link_from,
        'ppc_check': 1,
      };

      //TODO: Add this on profile page only
      if (showLead) {
        parameter.link_from = 3;
      }

      //eslint-disable-next-line no-undef
      // Open a new window immediately upon the click event
      let newWindow = window.open('', '_blank');

      //eslint-disable-next-line no-undef
      grecaptcha.ready(function () {
        //eslint-disable-next-line no-undef
        grecaptcha.execute('6Lfhk8kZAAAAALowInko8-L1jimR7PxS5qakeOBo', {action: 'validate_captcha'})
          .then(function (token) {
            parameter['g-recaptcha-response'] = token;

            if (newWindow) {
              newWindow.location.href = get(`${window.location.origin}/external_click.php`, parameter);
              newWindow.focus();
            }
          });
      });
    }

    //TODO: REMOVE
    window.subClick = function (vid, uid, ref, link_from, v_name) {
      $('#ppc-thanks').removeClass('hidden');
      $('#ppc-thanks .spinner').removeClass('hidden');
      $.ajax({
        url: '/external_click.php?vid=' + vid + '&uid=' + uid + '&ref=' + ref + '&link_from=' + link_from + '&fp=1',
        data: {
          vid: vid,
          uid: uid,
          ref: ref,
        },
        success: function (data) {
          if (data === 'sent') {
            $('#v_name').text(v_name);
            $('#ppc-thanks .invisible').removeClass('invisible');
            $('#ppc-thanks .spinner').addClass('hidden');
          } else {
            window.open(data, '_blank');
          }
          $('#cover-spin').hide();
        },
      });
    }

    $('.popup-item-close').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      $(this).parents('#ppc-thanks').addClass('hidden');
      enableScroll();
    });

    //LinkedIn Login
    $('.popup-parent .popup-item-close').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      $(this).parents('.popup-parent').addClass('hidden');
      enableScroll();
    });

    $('.linkedin-login').on('click', function () {
      $('.popup-parent').addClass('hidden');
      $('.linkedin-login-popup').removeClass('hidden');
    });

    //eslint-disable-next-line no-unused-vars
    window.linkedInLogin = function () {
      $('.popup-parent').addClass('hidden');
      $('.linkedin-login-popup').removeClass('hidden');
    }

    $('.open-column-popup').on('click', function () {
      $('.columns-popup').removeClass('hidden');
    });

    // FAQ's answer drawer
    window.toggleFaqAnswer = function (id) {
      $('#' + id + '-faq-answer').toggle()
      $('#' + id + '-faq-plus-vector').toggle()
      $('#' + id + '-faq-minus-vector').toggle()
    }

    function initializePopover() {
      let popOverSettings = {
        placement: 'bottom',
        container: 'body',
        html: true,
        trigger: 'manual',
        offset: '125px 20px',
        selector: '[data-toggle="popover"]',
        content: function () {
          return $('#popover-content').html();
        },
      }

      $('[data-toggle="popover"]').popover(popOverSettings).on('mouseenter', function () {
        var _this = this;
        $(this).popover('show');
        $('.popover').on('mouseleave', function () {
          $(_this).popover('hide');
        });
      }).on('mouseleave', function () {
        var _this = this;
        setTimeout(function () {
          if (!$('.popover:hover').length) {
            $(_this).popover('hide');
          }
        }, 100);
      });

      $('[data-toggle="popover"]').on('shown.bs.popover', function () {
        $('.popover .popover-body').find('.linkedin-login').attr('href', 'javascript:;');
        $('.popover .popover-body').find('.linkedin-login').attr('onclick', 'linkedInLogin();');
      });
    }

    window.removePplItem = function (close, slug) {
      $(close).parent().remove();
      finalTopThreePplVendor = finalTopThreePplVendor.filter(val => slug !== val.slug);
      if (finalTopThreePplVendor.length === 0) {
        $('.ppl-popup').addClass('hidden');
        enablePopUpScroll();
        // eslint-disable-next-line no-unused-vars
        if (window.topThreePplVendorSlugs !== undefined) {
          // eslint-disable-next-line no-undef
          finalTopThreePplVendor = JSON.parse(topThreePplVendorSlugs);
        }
      }
      requestFormFunction(finalTopThreePplVendor);
    }

    function enablePopUpScroll() {
      $('body').removeClass('disable-scroll');
      window.scrollTo(0, $('body').css('top').replace('-', '').replace('px', ''));
      $('body').removeAttr('style');
    }

    function generatePplPopupVendors(vendors = []) {
      $('.popup-items-container').html('');
      if (vendors.length > 0) {
        vendors.forEach(function ($vendor) {
          let popupItems = '<div class="ppl-popup-item d-flex justify-content-center align-items-center">\n' +
            '                    <div onClick="removePplItem(this,\'' + $vendor['slug'] + '\')" class="ppl-item-close position-absolute text-red font-size-9">\n' +
            '                      <i class="fal fa-times-circle fa-2x"></i>\n' +
            '                    </div>\n' +
            '                    <img class="mx-auto" src="https://d36w3vgtkvgnsp.cloudfront.net/' + $vendor['logo'] + '" alt="' + $vendor['name'] + '"/>\n' +
            '                  </div>';

          $('.popup-items-container').append(popupItems);
        });

        requestFormFunction(vendors);
      }
    }

    function requestFormFunction(vendors = []) {
      let slug = [];

      //eslint-disable-next-line no-undef, no-unused-vars
      vendors.forEach(function (item) {
        let newSlug = {
          slug: item.slug,
        }

        slug.push(newSlug)
      });

      //eslint-disable-next-line no-undef, no-unused-vars
      let productSlug = $('#product-slug').val();
      let functionAttr = 'sendPplRequest(this, ' + JSON.stringify(slug) + ', \'' + productSlug + '\')';

      $('.send-ppl-request').attr('onclick', functionAttr);
    }

    function enableScroll() {
      $('body').removeClass('disable-scroll');

      const topPos = $('body').css('top').replace('-', '').replace('px', '');
      $('body').removeAttr('style');
      $('html, body').animate({
        scrollTop: topPos,
      }, 0);
    }
  },
  finalize() {
  },
};
